const SEMVER_RE = /^\d+\.\d+\.\d+$/;

let injected = false;

export async function loadCMP(): Promise<void> {
  if (injected) return;
  const baseUrl = resolveBaseUrl();
  if (!baseUrl) {
    console.error('[CMP loader] Unable to resolve base URL — document.currentScript is null');
    return;
  }
  let version: string;
  try {
    const response = await fetch(`${baseUrl}version.json?${Math.random()}`, { cache: 'no-store' });
    if (!response.ok) {
      console.error(`[CMP loader] version.json fetch failed: HTTP ${response.status}`);
      return;
    }
    const payload = await response.json();
    if (!isValidVersion(payload?.version)) {
      console.error('[CMP loader] version.json is malformed:', payload);
      return;
    }
    version = payload.version;
  } catch (err) {
    console.error('[CMP loader] version.json fetch threw:', err);
    return;
  }
  const script = document.createElement('script');
  script.src = `${baseUrl}cmp.${version}.iife.js`;
  script.defer = true;
  document.head.appendChild(script);
  injected = true;
}

function resolveBaseUrl(): string | null {
  const current = document.currentScript as HTMLScriptElement | null;
  if (!current || !current.src) return null;
  const slash = current.src.lastIndexOf('/');
  return slash >= 0 ? current.src.slice(0, slash + 1) : null;
}

function isValidVersion(v: unknown): v is string {
  return typeof v === 'string' && SEMVER_RE.test(v);
}

if (typeof document !== 'undefined' && document.currentScript) {
  loadCMP();
}
